module.exports = __webpack_public_path__ + "img/meeting_room.8de6c3e5.svg";